import {
  AdjustableShelvesIcon,
  BellIcon,
  FingerprintIcon,
  IceCubesIcon,
  ThermometerIcon,
  WaterDropIcon,
  WifiIcon
} from './icons';

// Icon object constants for reuse
const ADJUSTABLE_DOOR_STORAGE = { text: 'Adjustable Door Storage', icon: AdjustableShelvesIcon };
const ADJUSTABLE_SHELVES = { text: 'Adjustable Shelves', icon: AdjustableShelvesIcon };
const ICE_MAKER_REMOVABLE_BASKET = { text: 'Ice Maker w/Removable Basket', icon: IceCubesIcon };
const FREEZER_TEMP_CONTROL = { text: 'Freezer Temp Control', icon: ThermometerIcon };
const DOOR_ALARM = { text: 'Door Alarm', icon: BellIcon };
const PRINTPROOF_STAINLESS_STEEL = { text: 'PrintProof Stainless Steel', icon: FingerprintIcon };
const CRUSHED_CUBED_ICE = { text: 'Crushed & Cubed Ice', icon: IceCubesIcon };
const SMART_HOME_ENABLED = { text: 'Smart Home Enabled', icon: WifiIcon };
const FINGERPRINT_RESISTANT = { text: 'Fingerprint Resistant', icon: FingerprintIcon };
const EXTERNAL_ICE_DISPENSER = { text: 'External Ice Dispenser', icon: IceCubesIcon };
const EXTERNAL_WATER_DISPENSER = { text: 'External Water Dispenser', icon: WaterDropIcon };
const INTERNAL_WATER_DISPENSER = { text: 'Internal Water Dispenser', icon: WaterDropIcon };
const INTERNAL_ICE_DISPENSER = { text: 'Internal Ice Dispenser', icon: IceCubesIcon };
const SMUDGE_PROOF_STAINLESS_STEEL = { text: 'Smudge-Proof Stainless Steel', icon: FingerprintIcon };

export const itemToIconsMap = {
  205065350: [
    ADJUSTABLE_DOOR_STORAGE,
    ICE_MAKER_REMOVABLE_BASKET,
    FREEZER_TEMP_CONTROL
  ],
  206452443: [
    DOOR_ALARM,
    ICE_MAKER_REMOVABLE_BASKET,
    FREEZER_TEMP_CONTROL
  ],
  302253240: [
    PRINTPROOF_STAINLESS_STEEL,
    CRUSHED_CUBED_ICE,
    SMART_HOME_ENABLED
  ],
  302785353: [
    FINGERPRINT_RESISTANT,
    CRUSHED_CUBED_ICE,
    EXTERNAL_ICE_DISPENSER
  ],
  302786603: [
    FINGERPRINT_RESISTANT,
    CRUSHED_CUBED_ICE,
    EXTERNAL_WATER_DISPENSER
  ],
  308743988: [
    DOOR_ALARM,
    CRUSHED_CUBED_ICE,
    SMART_HOME_ENABLED
  ],
  311411352: [
    FINGERPRINT_RESISTANT,
    CRUSHED_CUBED_ICE,
    SMART_HOME_ENABLED
  ],
  317987058: [
    DOOR_ALARM,
    FINGERPRINT_RESISTANT,
    INTERNAL_WATER_DISPENSER
  ],
  317987099: [
    DOOR_ALARM,
    FINGERPRINT_RESISTANT,
    CRUSHED_CUBED_ICE
  ],
  318840093: [
    DOOR_ALARM,
    FINGERPRINT_RESISTANT,
    CRUSHED_CUBED_ICE
  ],
  319236498: [
    DOOR_ALARM,
    FINGERPRINT_RESISTANT,
    CRUSHED_CUBED_ICE
  ],
  320243591: [
    ADJUSTABLE_SHELVES,
    FINGERPRINT_RESISTANT,
    INTERNAL_WATER_DISPENSER
  ],
  320970662: [
    DOOR_ALARM,
    CRUSHED_CUBED_ICE,
    EXTERNAL_WATER_DISPENSER
  ],
  322038211: [
    DOOR_ALARM,
    PRINTPROOF_STAINLESS_STEEL,
    INTERNAL_ICE_DISPENSER
  ],
  325158253: [
    DOOR_ALARM,
    PRINTPROOF_STAINLESS_STEEL,
    CRUSHED_CUBED_ICE
  ],
  325158262: [
    DOOR_ALARM,
    CRUSHED_CUBED_ICE,
    SMART_HOME_ENABLED
  ],
  326195150: [
    CRUSHED_CUBED_ICE,
    EXTERNAL_WATER_DISPENSER,
    SMART_HOME_ENABLED
  ],
  328604636: [
    DOOR_ALARM,
    SMUDGE_PROOF_STAINLESS_STEEL,
    INTERNAL_WATER_DISPENSER
  ]
};

export const validItemIds = new Set(Object.keys(itemToIconsMap));

/**
 * Check if an item ID has any associated icons
 * @param {string} itemId - The item ID to check
 * @returns {boolean} - True if the item ID is valid and has icons
 */
export const isValidItemId = (itemId) => {
  return validItemIds.has(itemId);
};

/**
 * Get all icons for a given item ID
 * @param {string} itemId - The item ID to get icons for
 * @returns {Array<{text: string, icon: React.Component}>|null} - Array of icon objects or null if not found
 */
export const getIconsByItemId = (itemId) => {
  return itemToIconsMap[itemId] || [];
};
